module.exports = __webpack_public_path__ + "static/media/building-content.3cf46a2a.png";